import getBrandedFooterLimit from './branded-footer-limit';
import getBrandedHeaderLimit from './branded-header-limit';
import getCompanyLogo from './company-logo';
import getCompanyLogoWidth from './company-logo-width';
import getLimits from './limits';
import getPartnerId from './partner-id';
import getSettings from './settings';
import getSiteFooter from './site-footer';
import getSiteHeader from './site-header';
import getUpsells from './upsells';
import getUserData from './user-data';
import getUserId from './user-id';
import getSiteURL from './site-url';
import getRequestBlock from './request-block';
import getRequestWidget from './request-widget';
import getDialogVisibility from './dialog-visibility';

export default {
  getBrandedFooterLimit,
  getBrandedHeaderLimit,
  getCompanyLogo,
  getCompanyLogoWidth,
  getLimits,
  getPartnerId,
  getSettings,
  getSiteFooter,
  getSiteHeader,
  getUpsells,
  getRequestBlock,
  getUserData,
  getUserId,
  getSiteURL,
  getRequestWidget,
  getDialogVisibility,
};
